const {
    GET_SALES_REPORT,
    SALES_REPORT_NOTIFICATION,
  } = require('redux/admin-constants');

  const initialState = {
    salesReport: [],
    salesReportNotification: {
      message: '',
      isSuccess: 1,
    },
  }; 

  const reducer = (state = initialState, action) => {
    const { type, payload } = action;
  
    switch (type) {
      case GET_SALES_REPORT: {
        return {
          ...state,
          salesReport: payload,
        };
      }
     
      case SALES_REPORT_NOTIFICATION: {
        return {
          ...state,
          salesReportNotification: payload.message
            ? payload
            : initialState.salesReportNotification,
        };
      }
      default:
        return state;
    }
  };
  
  export default reducer;